import Nav from '@components/Nav/Nav';
import logo from '@static/vectors/logo/icon.svg';
import { useState } from 'react';
import { Outlet } from 'react-router';
import './PageLayout.css';

export default function PageLayout() {
	const [pageId, setPageId] = useState('');
	return (
		<div id={pageId} className="page page-layout scrollbar-thin">
			<aside className="page-sidebar" id={`${pageId}-sidebar`}>
				<img src={logo} alt="trueflag icon" />
				<Nav />
			</aside>
			<main className="page-main" id={`${pageId}-main`}>
				<Outlet context={setPageId} />
			</main>
		</div>
	);
}
